<script lang="ts">
  import { onMount } from "svelte"
  import { xhr, toast, wait } from "$app/utils"
  import Honeybadger from "$app/utils/honeybadger"
  import StatementForm from "$app/Pages/Plans/Onboarding/components/StatementForm.svelte"
  import Navigation from "./Navigation.svelte"
  import { onboardingStore } from "./onboarding.svelte"
  import { appStore } from "$app/store.svelte"

  import bg from "@images/onboarding/bg-eclipse.jpg"
  import img from "@images/onboarding/brand_purpose.png"
  import PrevNextSkipButtons from "$app/Pages/Plans/Onboarding/components/PrevNextSkipButtons.svelte"

  onboardingStore.completed = true
  let brand_purpose: StatementType = $state(null)

  let loaded: boolean = $state(false)
  async function getBrandPurpose(): Promise<StatementType> {
    try {
      const resp = await xhr.get(
        `/plan_onboarding/${appStore.plan.id}/get_statements.json?statement_type=brand_purpose`
      )

      brand_purpose = resp.data
    } catch (e) {
      console.error(e)
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
      toast("There was an error loading the Brand Purpose", "error")
    } finally {
      loaded = true
      return brand_purpose
    }
  }

  onMount(() => {
    getBrandPurpose()
    onboardingStore.setBrowserHistory({}, "brand_purpose")
  })
</script>

<div class="mx-auto px-2 lg:px-6 pt-4 w-full pb-8 lg:pb-20 lg:text-left">
  <div class="px-4 w-full">
    <Navigation step="brand_purpose" on:updateStep />
  </div>
  <div class="px-4 w-full lg:w-1/2 xl:pr-16">
    <h2 class="mt-12 text-5xl font-bold text-left text-white">
      What Is Your Brand Purpose?
    </h2>

    <p class="mt-8 text-white text-lg max-w-lg">
      The reason your company exists and the difference your products and
      services make in the world. It is sometimes referred to as your mission
      statement. It should be relevant 50 years in the future.
    </p>

    {#if loaded && brand_purpose}
      <div class="mt-8 max-w-lg">
        <StatementForm
          statement={brand_purpose}
          placeholder="Enter your Brand Purpose headline (< 5 words)"
          title={`Your Brand Purpose`}
          onupdate={(data) => {
            console.log("Brand Purpose updated", data)
            brand_purpose = data
          }}
        />
      </div>

      <PrevNextSkipButtons />
    {/if}
  </div>
</div>
<div
  class="relative w-full hidden lg:inline lg:absolute lg:inset-y-32 lg:-mb-32 rounded-tl-lg lg:-right-0 md:w-1/3 lg:w-1/2 bg-lwp-light-grey bg-right-bottom bg-no-repeat bg-contain"
  style="background-image: url({bg})"
>
  <img
    src={img}
    alt="Your Profile"
    class="absolute shadow-lg rounded border border-gray-500 inset-y-4 inset-x-6 xl:-inset-x-6 w-11/12 object-fill"
  />
</div>
